import { AxiosResponse } from 'axios';
import grispiApi from '../../apis/grispiApi';
import { ChatEntity, ChatResumeResponse, WSMessage } from '../../components/plugins/chat/types';
import { PluginDefinition } from '../../components/plugins/types';
import { fetcherWithToken } from '../../utils/fetchers';
import { sleep } from '../../utils/helpers';
import { getPluginStore } from '../../utils/store/getStore';
import endPoints from '../endpoints';

/**
 * *********************** Plugin related services ***********************
 * GET /apps - get all ENABLED plugins for tenant.
 * GET /apps/all - get all INSTALLED plugins for tenant.
 * GET /store/apps - get all AVAILABLE(to install) plugins for tenant.
 *
 */

export const getActivePlugins = async (): Promise<PluginDefinition[]> => {
    const pluginsList = await fetcherWithToken('/apps');

    return pluginsList;
};

export const activatePlugin = async (pluginId: string): Promise<void> => {
    await grispiApi.post(`/apps/${pluginId}/activation`);
};

export const deactivatePlugin = async (pluginId: string): Promise<void> => {
    await grispiApi.delete(`/apps/${pluginId}/activation`);
};

export const installPlugin = async (pluginId: string): Promise<void> => {
    await grispiApi.post(`/apps/${pluginId}`);
};

export const uninstallPlugin = async (pluginId: string): Promise<void> => {
    await grispiApi.delete(`/apps/${pluginId}`);
};

export const resumeChat = async (chatId: string): Promise<ChatResumeResponse> => {
    // console.debug('resumeChat', `POST ${endPoints.chat.resumeChat}${chatId}`);
    const response = await grispiApi.post(`${endPoints.chat.resumeChat}${chatId}`);
    if (response.status !== 200) {
        //TODO show error to user
        throw new Error(
            `Error occurred while resuming the chat [${chatId}]: ${response.status} ${response.statusText}`
        );
    }
    return response.data;
};

export const acceptChatFromQueue = async (): Promise<ChatEntity> => {
    // console.debug('acceptChatFromQueue');
    const response = await grispiApi.post(endPoints.chat.acceptChatFromQueue);
    return response.data;
};

export const getChatHistoryByChatId = async (chatId: string): Promise<WSMessage[]> => {
    // console.debug('getChatHistoryByChatId:', chatId);
    const response = await grispiApi.get(`${endPoints.chat.history[0]}${chatId}${endPoints.chat.history[1]}`);
    return response.data;
};
export const getChatHistoryByTicketKey = async <T extends { chatId: string; history: WSMessage[] }>(
    ticketKey: string
): Promise<{ chatId: string; history: WSMessage[] }> => {
    // console.debug('getChatHistoryByTicketKey ticketKey:', ticketKey);
    const response: AxiosResponse<T> = await grispiApi.get(`${endPoints.chat.historyByTicketKey}${ticketKey}`);
    return response.data;
};

export const getActiveChatEntities = async (): Promise<ChatEntity[]> => {
    // console.debug('getActiveChatEntities');
    const response = await grispiApi.get(endPoints.chat.activeChatEntities);
    // console.log(`getActiveChatEntities , response`, response.data);
    getPluginStore().setActiveChatEntities(response.data);

    return response.data;
};

export const sendACKFrameToChatHistory = async (_chatId: string): Promise<any> => {
    // console.debug('sendACKFrameToChatHistory chatId:', chatId);
    // const response = await grispiApi.patch(`${endPoints.chat.acknowledge[0]}${chatId}${endPoints.chat.acknowledge[1]}`);
    // return response.data;
    await sleep(1000);
    return true;
};
